<template>
    <div>
      <h3>Manage Locations</h3>
  
      <!-- Create New Location -->
      <form @submit.prevent="createLocation">
        <input
          type="text"
          v-model="locationName"
          class="form-control"
          placeholder="Enter location name"
          required
        />
        <button type="submit" class="btn btn-primary w-100 mt-3">Create Location</button>
      </form>
  
      <!-- Activate/Deactivate Locations -->
      <div class="mt-4">
        <h4>Active/Inactive Locations</h4>
        <ul class="list-group">
          <li
            v-for="location in locations"
            :key="location.id"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            {{ location.name }}
            <button
              @click="toggleLocationStatus(location)"
              :class="location.isActive ? 'btn btn-danger' : 'btn btn-success'"
            >
              {{ location.isActive ? 'Deactivate' : 'Activate' }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { db } from '@/firebase';
  import { collection, addDoc, getDocs, updateDoc, doc } from 'firebase/firestore';
  
  export default {
    name: 'ManageLocations',
    setup() {
      const locationName = ref('');
      const locations = ref([]);
  
      const fetchLocations = async () => {
        const locationsSnapshot = await getDocs(collection(db, 'locations'));
        locations.value = locationsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
      };
  
      onMounted(fetchLocations);
  
      const createLocation = async () => {
        try {
          await addDoc(collection(db, 'locations'), {
            name: locationName.value,
            isActive: true,
          });
          locationName.value = '';
          fetchLocations();
        } catch (e) {
          console.error('Error creating location: ', e);
        }
      };
  
      const toggleLocationStatus = async (location) => {
        try {
          const locationRef = doc(db, 'locations', location.id);
          await updateDoc(locationRef, {
            isActive: !location.isActive,
          });
          fetchLocations();
        } catch (e) {
          console.error('Error updating location: ', e);
        }
      };
  
      return {
        locationName,
        locations,
        createLocation,
        toggleLocationStatus,
      };
    },
  };
  </script>
  
  <style scoped>
  /* Add custom styles here */
  </style>
  